<template>
	<span @click="dialog = !dialog">
		<slot>
			<v-btn text color="primary" dark>{{ title }}</v-btn>
		</slot>
		<v-dialog v-model="dialog" scrollable max-width="300px" :fullscreen="localFullscreen">
			<v-card v-if="page">
				<v-card-title>{{ page.title }}</v-card-title>
				<v-divider></v-divider>
				<v-card-text style="height: 300px">
					<div class="" v-html="page.html" />
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-btn color="secondary" text @click="dialog = false">关闭</v-btn>
					<v-btn color="primary" text @click="localFullscreen = !localFullscreen">全屏阅读</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</span>
</template>

<script>
export default {
	props: {
		title: { type: String },
		code: { type: String },
		fullscreen: { type: Boolean, default: false }
	},
	data() {
		return {
			page: null,
			dialog: false,
			localFullscreen: false
		}
	},
	watch: {
		code(nv) {
			//有可能切换语言
			this.load()
		},
		dialog(nv) {
			if (nv) {
				this.load()
			}
		}
	},
	mounted() {
		this.load()
		this.localFullscreen = this.fullscreen
	},
	methods: {
		load() {
			this.$api.page.getById(this.code, (res) => {
				this.page = res
			})
		}
	},
	components: {}
}
</script>
<style scoped></style>
